// Dial-code lookups backed by libphonenumber-js so the international calling-code data stays
// maintained upstream instead of being hand-rolled and drifting out of date.
import {
  getCountries,
  getCountryCallingCode,
  isSupportedCountry,
} from "libphonenumber-js";

/** Dial code (without the leading "+") for an ISO alpha-2 code, or undefined if unknown/unset. */
export const getDialCode = (
  countryCode?: string | null
): string | undefined => {
  if (!countryCode) return undefined;
  const iso = countryCode.toUpperCase();
  return isSupportedCountry(iso) ? getCountryCallingCode(iso) : undefined;
};

/** Every ISO alpha-2 code that has a known dial code — used to build the dial-code picker. */
export const getDialCodeCountries = (): string[] => getCountries();
